angular.module('bmsApp.dashboard')
	.controller('DashboardEcommerceCtrl', DashboardEcommerceCtrl);

DashboardEcommerceCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'NgTableParams',
	'$ngBootbox',
	'notify',
	'InstanceSvc',
	'EcomDashboardSvc',
	'MMJobSvc',
	'SMJobSvc',
	'TGJobSvc',
];

function DashboardEcommerceCtrl(
	$scope,
	$state,
	$q,
	NgTableParams,
	$ngBootbox,
	notify,
	InstanceSvc,
	EcomDashboardSvc,
	MMJobSvc,
	SMJobSvc,
	TGJobSvc,
) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: null,
		handlers: handlers,
		newJobsTable: {},
		activeJobsTable: {},
	});

	let defaultNewJobParams = function () {
		let params = {
			page: 1, // show first page
			count: $scope.config.table.params.count, // count per page
			sorting: {

			},
			filter: {
			}
		};

		if (InstanceSvc.instance.isMM()) {
			angular.extend(params, {
				sorting: {
					id: 'desc' // initial sorting
				},
				filter: {
					converted: 1,
					orderConfirmed: false,
					ecom: true,
					active: true,
				}
			});
		}
		else if (InstanceSvc.instance.isSM()) {
			angular.extend(params, {
				sorting: {
					id: 'desc' // initial sorting
				},
				filter: {
					converted: true,
					closed: false,
					orderConfirmed: false,
					ecom: true,
					active: true,
				}
			});
		}
		else if (InstanceSvc.instance.isTG()) {
			angular.extend(params, {
				sorting: {
					id: 'desc' // initial sorting
				},
				filter: {
					orderConfirmed: false,
					ecom: true,
					active: true,
				}
			});
		}

		return params;
	};

	let defaultActiveJobParams = function () {
		let params = {
			page: 1, // show first page
			count: $scope.config.table.params.count, // count per page
			sorting: {

			},
			filter: {
			}
		};

		if (InstanceSvc.instance.isMM()) {
			angular.extend(params, {
				sorting: {
					id: 'desc' // initial sorting
				},
				filter: {
					converted: 1,
					ecomActive: true,
					orderConfirmed: true,
					ecom: true,
					active: true,
				}
			});
		}
		else if (InstanceSvc.instance.isSM()) {
			angular.extend(params, {
				sorting: {
					id: 'desc' // initial sorting
				},
				filter: {
					converted: true,
					closed: false,
					orderConfirmed: true,
					ecom: true,
					active: true,
					cancelled: false,
				}
			});
		}
		else if (InstanceSvc.instance.isTG()) {
			angular.extend(params, {
				sorting: {
					id: 'desc' // initial sorting
				},
				filter: {
					orderConfirmed: true,
					ecom: true,
					active: true,
				}
			});
		}

		return params;
	};


	this.$onInit = () => {
		loadNonRefunded();
		loadVisitDateChanged();
		loadNewJobs();
		loadActiveJobs();
	};

	function reloadAll() {
		loadNonRefunded();
		loadVisitDateChanged();
		self.newJobsTable.params.reload();
		self.activeJobsTable.params.reload();
	}

	function loadNonRefunded() {
		EcomDashboardSvc.nonRefundedJobs().then((response) => {
			self.nonRefundedJobs = response.data.jobs_collection;
		});
	}

	function loadVisitDateChanged() {
		EcomDashboardSvc.updatedVisitDates().then((response) => {
			self.updatedVisitDateJobs = response.data.jobs_collection;
		});
	}

	function loadNewJobs() {
		self.loadingNewJobs = true;
		let newJobTableOptions = {
			total: 0, // length of data
			counts: $scope.config.table.settings.counts, // available page counts
			getData: function ($defer, params) {
				if (InstanceSvc.instance.isMM()) {
					MMJobSvc.index(params.$params)
						.then(function (response) {
							params.total(response.data.job_filtered_count);
							$defer.resolve(response.data.job_collection);
							self.loadingNewJobs = false;
							// self.table.updating = false;
						});
				}
				else if (InstanceSvc.instance.isSM()) {
					SMJobSvc.index(params.$params)
						.then(function (response) {
							params.total(response.data.sm_job_filtered_count);
							$defer.resolve(response.data.sm_job_collection);
							self.loadingNewJobs = false;
							// self.table.updating = false;
						});
				}
				else if (InstanceSvc.instance.isTG()) {
					TGJobSvc.index(params.$params)
						.then(function (response) {
							params.total(response.data.tg_job_filtered_count);
							$defer.resolve(response.data.tg_job_collection);
							self.loadingNewJobs = false;
							// self.table.updating = false;
						});
				}
			}
		};

		let newJobParams = defaultNewJobParams();
		self.newJobsTable.params = new NgTableParams(newJobParams, newJobTableOptions);
	}

	function loadActiveJobs() {
		self.loadingActiveJobs = true;
		let activeJobTableOptions = {
			total: 0, // length of data
			counts: $scope.config.table.settings.counts, // available page counts
			getData: function ($defer, params) {
				if (InstanceSvc.instance.isMM()) {
					MMJobSvc.index(params.$params)
						.then(function (response) {
							params.total(response.data.job_filtered_count);
							$defer.resolve(response.data.job_collection);
							self.loadingActiveJobs = false;
							// self.table.updating = false;
						});
				}
				else if (InstanceSvc.instance.isSM()) {
					SMJobSvc.index(params.$params)
						.then(function (response) {
							params.total(response.data.sm_job_filtered_count);
							$defer.resolve(response.data.sm_job_collection);
							self.loadingActiveJobs = false;
							// self.table.updating = false;
						});
				}
				else if (InstanceSvc.instance.isTG()) {
					TGJobSvc.index(params.$params)
						.then(function (response) {
							params.total(response.data.tg_job_filtered_count);
							$defer.resolve(response.data.tg_job_collection);
							self.loadingActiveJobs = false;
							// self.table.updating = false;
						});
				}
			}
		};

		let activeJobParams = defaultActiveJobParams();
		self.activeJobsTable.params = new NgTableParams(activeJobParams, activeJobTableOptions);
	}

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.confirmJob = (event, job) => {
		event.stopPropagation();
		job.disabledBtn = true;
		$ngBootbox.confirm('Are you sure you wish to CONFIRM this job? This will send the customer either an email or SMS as confirmation')
			.then(function () {
				let params = {
					'class': job.class,
					jobId: job.id,
				};
				return EcomDashboardSvc.confirmJob(params).then((response) => {
					reloadAll();
				}).finally(() => {
					job.disabledBtn = false;
				})
			});
	};

	handlers.cancelJob = (event, job) => {
		event.stopPropagation();
		job.disabledBtn = true;
		if (job.class === "App\\Models\\Merrymaids\\Job") {
			return MMJobSvc.showCancelJobModal(job)
				.then(function (result) {
					if (result.success) {
						reloadAll();
					}
				}).finally(() => {
					job.disabledBtn = false;
				});
		}
		else if (job.class === "App\\Models\\Sm\\Job") {
			return SMJobSvc.cancel.showModal(job).then(function(result) {
				notify({
					message: 'Job cancelled',
				});
				reloadAll();
			}).finally(() => {
				job.disabledBtn = false;
			});
		}
		else if (job.class === "App\\Models\\Trugreen\\Job") {
			return TGJobSvc.showCancelJobModal(job).then(function(result) {
				reloadAll();
			}).finally(() => {
				job.disabledBtn = false;
			});
		}

	};

	handlers.markAsRefundedClick = (event, job) => {
		return EcomDashboardSvc.markRefunded({id: job.id}).then((response) => {
			loadNonRefunded();
		});
	};

	handlers.jobClick = (job) => {
		if (job.class === "App\\Models\\Merrymaids\\Job") {
			$state.go('main.merrymaids.job.read', {jobId: job.id});
		}
		else if (job.class === "App\\Models\\Sm\\Job") {
			$state.go('main.sm.job.index.view', {jobId: job.id});
		}
		else if (job.class === "App\\Models\\Trugreen\\Job") {
			$state.go('main.trugreen.quote.index.view', {quoteId: job.id});
		}
	};

	handlers.showAvailabilityClick = () => {
		EcomDashboardSvc.showAvailabilityModal();
	};

	handlers.visitChangedClick = (event, job) => {
		return EcomDashboardSvc.sendVisitChanged({id: job.id}).then((response) => {
			loadVisitDateChanged();
		});
	};

	handlers.ignoreVisitChangedClick = (event, job) => {
		return EcomDashboardSvc.ignoreUpdatedVisitDates({id: job.id}).then((response) => {
			loadNonRefunded();
		});
	};
}